export default "__VITE_PUBLIC_ASSET__b081ac14__"